import { Box, Container, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const PanelBox = ({ children, title }) => {
    return (
        <Container component='main' maxWidth='xl'>
            <Box marginTop={5}>
                <Typography variant='h5' fontWeight='bold' marginBottom={3}>
                    {title}
                </Typography>
                {children}
            </Box>
        </Container>
    )
}

PanelBox.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired
}

export default PanelBox
